export const selectResult = (state) => state.contactUs.result;
export const selectError = (state) => state.contactUs.error;
export const selectLoading = (state) => state.contactUs.loading;
